<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 10 14">
    <path d="M8.5 7.5v-5h-3.5v8.883q0.93-0.492 1.664-1.070 1.836-1.438 1.836-2.812zM10 1.5v6q0 0.672-0.262 1.332t-0.648 1.172-0.922 0.996-0.988 0.805-0.945 0.605-0.699 0.387-0.332 0.156q-0.094 0.047-0.203 0.047t-0.203-0.047q-0.125-0.055-0.332-0.156t-0.699-0.387-0.945-0.605-0.988-0.805-0.922-0.996-0.648-1.172-0.262-1.332v-6q0-0.203 0.148-0.352t0.352-0.148h9q0.203 0 0.352 0.148t0.148 0.352z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-shield.html